import { Avatar, Layout, Menu, Popover, Tooltip } from 'antd';
import MaterialIcon from 'material-icons-react';
import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { loadLogin } from '../auth/localStorage';
import Config from '../config/configComponent';
import LawDocument from '../lawdocument/lawdocumentComponent';
import LawReport from '../lawreport/lawReportComponent';
import LawReportEditComponent from '../lawreport/lawReportEditComponent';
import { logout } from '../login/loginActions';
import Login from '../login/loginComponent';
import Newsletter from '../newsletter/newsletterComponent';
import NewsletterEdit from '../newsletter/newsletterEditComponent';
import Organization from '../pages/organization/organization';
import OrganizationList from '../pages/organization/organizationList';
import Templates from '../templates/templateComponent';
import Sba from '../sba/sbaComponent';
import Sbl from '../sbl/sblComponent';
import Sbt from '../sbt/sbtComponent';
import SbtUpload from '../sbt/sbtUploadComponent';
import NewsEntry from '../newsentry/newsentryComponent';
import SearchComponent from '../search/searchComponent';
import SearchResultComponent from '../search/searchResultComponent';
import User from '../user/userComponent';
import Eliterature from '../eliterature/eliteratureComponent';
import MaintenancePage from '../pages/maintenance/maintenancePage';

import { ENV } from '../utils/http';

const { Header, Content, Sider } = Layout;

const PrivateRoute = ({ component: Component, authed, ...rest }) => {
	return (
		<Route
			{...rest}
			render={(props) =>
				authed === true ? (
					<Component {...props} />
				) : (
					<Redirect to={{ pathname: '/', state: { from: props.location } }} />
				)
			}
		/>
	);
};

class App extends React.Component {
	menuItemSelected = (a) => {
		this.props.history.push(a.key);
	};

	onLogout = () => {
		this.props.dispatch(logout());
	};

	render() {
		let loggedIn = this.props.user && this.props.user.accessKey;
		let logoutLink = (
			<a href='#' onClick={this.onLogout}>
				Logga ut
			</a>
		);

		let authenticated = loadLogin().login !== undefined;

		let { pathname } = this.props.location;
		let menuKey =
			pathname.indexOf('rattsfallsokning') >= 0 || pathname.indexOf('rattsfall/') >= 0
				? '/rattsfall'
				: pathname;
		menuKey = pathname.indexOf('lagdel/lag') >= 0 ? '/lagdel' : menuKey;
		menuKey = pathname.indexOf('nyhetsbrev/') >= 0 ? '/nyhetsbrev' : menuKey;
		menuKey = pathname.indexOf('kund') >= 0 ? '/kunder' : menuKey;

		if (!ENV.isLocal()) {
			window.gtag('config', 'UA-129705352-1', {
				page_path: pathname,
			});
		}

		return (
			<Layout style={{ minHeight: '100vh' }}>
				{loggedIn && (
					<Header className='header'>
						<img src='/logo.jpg' style={{ width: 150 }} alt={'infosoc.se'} />

						<SearchComponent />

						<div style={{ float: 'right' }}>
							<Popover
								placement='bottomRight'
								title={this.props.user.organizationName}
								content={logoutLink}
								trigger='click'
							>
								<Avatar size='large' icon='user' />
							</Popover>
						</div>
					</Header>
				)}
				<Layout>
					{loggedIn && (
						<Sider className='main-navigation' theme='light'>
							<Menu
								style={{ marginTop: 10 }}
								theme='light'
								selectedKeys={[menuKey]}
								mode='inline'
								onClick={this.menuItemSelected}
							>
								<Menu.Item key='/rattsfall'>
									<Tooltip placement='right' title={'Rättsfall m.m.'}>
										<MaterialIcon icon='gavel' size={20} />{' '}
									</Tooltip>
								</Menu.Item>
								<Menu.Item key='/mallar'>
									<Tooltip placement='right' title={'Mallar'}>
										<MaterialIcon icon='content_copy' size={20} />{' '}
									</Tooltip>
								</Menu.Item>
								<Menu.Item key='/lagdel'>
									<Tooltip placement='right' title={'Lagdel'}>
										<MaterialIcon icon='book' size={20} />{' '}
									</Tooltip>
								</Menu.Item>
								<Menu.Item key='/nyhetsbrev'>
									<Tooltip placement='right' title={'Nyhetsbrev'}>
										<MaterialIcon icon='email' size={20} />{' '}
									</Tooltip>
								</Menu.Item>
								<Menu.Item key='/nyheter'>
									<Tooltip placement='right' title={'Nyheter på startsidan'}>
										<MaterialIcon icon='home' size={20} />{' '}
									</Tooltip>
								</Menu.Item>
								<Menu.Item key='/kunder'>
									<Tooltip placement='right' title={'Kunder'}>
										<MaterialIcon icon='people' size={20} />{' '}
									</Tooltip>
								</Menu.Item>
								{this.props.user.powerUser && (
									<Menu.Item key='/installningar'>
										<Tooltip placement='right' title={'Admin'}>
											<MaterialIcon icon='build' size={20} />{' '}
										</Tooltip>
									</Menu.Item>
								)}
								{this.props.user.powerUser && (
									<Menu.Item key='/kund/1'>
										<Tooltip placement='right' title={'Användare'}>
											<MaterialIcon icon='person' size={20} />{' '}
										</Tooltip>
									</Menu.Item>
								)}
								{this.props.user.powerUser && (
									<Menu.Item key='/underhall'>
										<Tooltip placement='right' title={'Underhåll'}>
											<MaterialIcon icon='health_and_safety' size={20} />{' '}
										</Tooltip>
									</Menu.Item>
								)}
							</Menu>
						</Sider>
					)}
					<Layout>
						<Content style={{ height: 'calc(100vh - 60px)' }}>
							<Switch>
								<Route exact path='/' component={Login} />
								<PrivateRoute
									exact
									path='/rattsfall'
									component={LawReport}
									authed={authenticated}
								/>
								<PrivateRoute exact path='/rattsfall/:id' component={Sbt} authed={authenticated} />
								<PrivateRoute
									exact
									path='/rattsfall-uppladdning'
									component={SbtUpload}
									authed={authenticated}
								/>
								<PrivateRoute
									exact
									path='/kunder'
									component={OrganizationList}
									authed={authenticated}
								/>
								<PrivateRoute exact path='/mallar' component={Templates} authed={authenticated} />
								<PrivateRoute exact path='/lagdel' component={LawDocument} authed={authenticated} />
								<PrivateRoute exact path='/lagdel/lag/:id' component={Sbl} authed={authenticated} />
								<PrivateRoute
									exact
									path='/lagdel/lag/:id/andringar'
									component={Sba}
									authed={authenticated}
								/>
								<PrivateRoute
									exact
									path='/blanketter'
									component={() => <div />}
									authed={authenticated}
								/>
								<PrivateRoute
									exact
									path='/nyhetsbrev'
									component={Newsletter}
									authed={authenticated}
								/>
								<PrivateRoute
									exact
									path='/nyhetsbrev/:id'
									component={NewsletterEdit}
									authed={authenticated}
								/>
								<PrivateRoute
									exact
									path='/installningar'
									component={Config}
									authed={authenticated}
								/>
								<PrivateRoute exact path='/anvandare/:id' component={User} authed={authenticated} />
								<PrivateRoute
									exact
									path='/kund/:orgId'
									component={Organization}
									authed={authenticated}
								/>
								<PrivateRoute
									exact
									path='/elitterature/:id'
									component={Eliterature}
									authed={authenticated}
								/>
								<PrivateRoute
									exact
									path='/sokning'
									component={SearchResultComponent}
									authed={authenticated}
								/>
								<PrivateRoute
									exact
									path='/rattsfallsokning/:searchType'
									component={LawReportEditComponent}
									authed={authenticated}
								/>
								<PrivateRoute exact path='/nyheter' component={NewsEntry} authed={authenticated} />
								<PrivateRoute
									exact
									path='/underhall'
									component={MaintenancePage}
									authed={authenticated}
								/>
							</Switch>
						</Content>
					</Layout>
				</Layout>
			</Layout>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.login.user,
	};
};

export default connect(mapStateToProps)(withRouter(App));



// WEBPACK FOOTER //
// ./src/app/appComponent.js